var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    {
      staticClass: "row view-panel",
      class: { toggle: _vm.toggle },
      attrs: { show: _vm.loadingFile }
    },
    [
      _c("div", { staticClass: "col-md-12 button-panel" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-end" },
          [
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED082",
                  expression: "'ED082'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Buscar",
                  expression: "'Buscar'"
                }
              ],
              staticClass: "action mr-2",
              attrs: {
                radius: "",
                color: "primary",
                icon: "search",
                "data-cy": "search"
              },
              on: {
                click: function($event) {
                  return _vm.goToSearch()
                }
              }
            }),
            _c("span", { staticClass: "separator" }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED144",
                  expression: "'ED144'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Nuevo documento predefinido",
                  expression: "'Nuevo documento predefinido'"
                }
              ],
              staticClass: "action mr-2",
              attrs: {
                radius: "",
                color: "primary",
                icon: "note_add",
                "data-cy": "new-document",
                disabled: !_vm.canEdit
              },
              on: { click: _vm.newDocument }
            }),
            _vm.actualFolder && _vm.actualFolder.type === "folder"
              ? _c("vs-button", {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED275",
                      expression: "'ED275'"
                    },
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Nuevo documento desde template",
                      expression: "'Nuevo documento desde template'"
                    }
                  ],
                  staticClass: "action mr-2",
                  class: { "cursor-not-allowed": _vm.noHavPermissions },
                  attrs: {
                    radius: "",
                    color: "primary",
                    icon: "content_copy",
                    "data-cy": "new-document-template",
                    disabled: _vm.noHavPermissions || !_vm.canEdit
                  },
                  on: { click: _vm.handleNewTemplateDocument }
                })
              : _vm._e(),
            _c("vs-button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeElement && _vm.activeElement.type === "file",
                  expression: "activeElement && activeElement.type === 'file'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Ver",
                  expression: "'Ver'"
                }
              ],
              staticClass: "action mr-2",
              attrs: {
                radius: "",
                color: "primary",
                icon: "file_download",
                "data-cy": "open-element"
              },
              on: { click: _vm.openElement }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED082|FEB99",
                  expression: "'ED082|FEB99'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.getSelectedRepositoryId || _vm.getSelectedFolderId,
                  expression: "getSelectedRepositoryId || getSelectedFolderId"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Agregar carpeta",
                  expression: "'Agregar carpeta'"
                }
              ],
              staticClass: "action mr-2",
              attrs: {
                radius: "",
                color: "primary",
                icon: "create_new_folder",
                "data-cy": "add-folder",
                disabled:
                  _vm.userPermissions.write === 0 &&
                  _vm.userPermissions.totalControl === 0
              },
              on: { click: _vm.addFolder }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED092|FEB99",
                  expression: "'ED092|FEB99'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement && _vm.activeElement.type === "folder",
                  expression: "activeElement && activeElement.type === 'folder'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Editar carpeta",
                  expression: "'Editar carpeta'"
                }
              ],
              staticClass: "action mr-2",
              class: { "cursor-not-allowed": _vm.isReadOnly },
              attrs: {
                radius: "",
                color: "primary",
                icon: "edit",
                "data-cy": "edit",
                disabled: _vm.isReadOnly
              },
              on: { click: _vm.editFolder }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED093|FEB99",
                  expression: "'ED093|FEB99'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement && _vm.activeElement.type === "folder",
                  expression: "activeElement && activeElement.type === 'folder'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Eliminar carpeta",
                  expression: "'Eliminar carpeta'"
                }
              ],
              staticClass: "action mr-2",
              class: {
                "cursor-not-allowed": _vm.isReadOnly
              },
              attrs: {
                radius: "",
                color: "primary",
                icon: "delete",
                "data-cy": "delete-folder",
                disabled: _vm.isReadOnly
              },
              on: { click: _vm.deleteFolder }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED084",
                  expression: "'ED084'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement && _vm.activeElement.type === "folder",
                  expression: "activeElement && activeElement.type === 'folder'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Kanban de carpeta",
                  expression: "'Kanban de carpeta'"
                }
              ],
              staticClass: "action mr-2",
              class: { "cursor-not-allowed": _vm.noHavPermissions },
              attrs: {
                radius: "",
                color: "primary",
                icon: "grid_view",
                "data-cy": "kanban-folder",
                disabled: _vm.noHavPermissions
              },
              on: { click: _vm.goToKanbanFolder }
            }),
            _vm.activeElement &&
            _vm.activeElement.type === "file" &&
            !_vm.isGore &&
            !_vm.isInh
              ? _c("vs-button", {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED078",
                      expression: "'ED078'"
                    },
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Enviar a flujo.",
                      expression: "'Enviar a flujo.'"
                    }
                  ],
                  staticClass: "action mr-2",
                  class: {
                    "cursor-not-allowed": _vm.noHavPermissions || !_vm.canEdit
                  },
                  attrs: {
                    radius: "",
                    color: "primary",
                    icon: "call_split",
                    "data-cy": "send-to-flow",
                    disabled: _vm.noHavPermissions || !_vm.canEdit
                  },
                  on: { click: _vm.sendToFlow }
                })
              : _vm._e(),
            _vm.activeElement &&
            _vm.activeElement.type === "file" &&
            (_vm.isGore || _vm.isInh)
              ? _c("vs-button", {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED078",
                      expression: "'ED078'"
                    },
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Enviar a flujo.",
                      expression: "'Enviar a flujo.'"
                    }
                  ],
                  staticClass: "action mr-2",
                  class: {
                    "cursor-not-allowed": _vm.noHavPermissions || !_vm.canEdit
                  },
                  attrs: {
                    radius: "",
                    color: "primary",
                    icon: "call_split",
                    "data-cy": "send-to-flow",
                    disabled: _vm.noHavPermissions || !_vm.canEdit
                  },
                  on: { click: _vm.sendToFlowGoreConfirm }
                })
              : _vm._e(),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED083",
                  expression: "'ED083'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.getSelectedRepositoryId || _vm.getSelectedFolderId,
                  expression: "getSelectedRepositoryId || getSelectedFolderId"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Agregar documento",
                  expression: "'Agregar documento'"
                }
              ],
              staticClass: "action mr-2",
              attrs: {
                radius: "",
                color: "primary",
                icon: "cloud_upload",
                "data-cy": "add-file",
                disabled: _vm.isReadOnly
              },
              on: { click: _vm.addFile }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED243",
                  expression: "'ED243'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement && _vm.activeElement.type === "folder",
                  expression: "activeElement && activeElement.type === 'folder'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Descargar carpeta",
                  expression: "'Descargar carpeta'"
                }
              ],
              staticClass: "action mr-2",
              attrs: {
                radius: "",
                color: "primary",
                icon: "cloud_download",
                "data-cy": "add-file"
              },
              on: { click: _vm.downloadFolder }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED240",
                  expression: "'ED240'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement && _vm.activeElement.type === "folder",
                  expression: "activeElement && activeElement.type === 'folder'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Enviar carpeta a flujo",
                  expression: "'Enviar carpeta a flujo'"
                }
              ],
              staticClass: "action mr-2",
              class: {
                "cursor-not-allowed":
                  _vm.userPermissions.read === 0 &&
                  _vm.userPermissions.write === 0 &&
                  _vm.userPermissions.totalControl === 0
              },
              attrs: {
                radius: "",
                color: "primary",
                icon: "call_split",
                "data-cy": "send-folder-to-flow",
                disabled:
                  (_vm.userPermissions.read === 0 &&
                    _vm.userPermissions.write === 0 &&
                    _vm.userPermissions.totalControl === 0) ||
                  !_vm.canEdit
              },
              on: { click: _vm.sendFolderToFlow }
            }),
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c(
                  "vs-button",
                  {
                    directives: [
                      {
                        name: "has-permission",
                        rawName: "v-has-permission",
                        value: "ED239",
                        expression: "'ED239'"
                      },
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Seleccionar archivos para enviar a flujo",
                        expression: "'Seleccionar archivos para enviar a flujo'"
                      }
                    ],
                    staticClass: "mr-2",
                    class: {
                      "pr-2":
                        !_vm.navigationElementsSelectionEnabled &&
                        _vm.selectionType !==
                          _vm.selectionTypes.SEND_FILE_TO_FLOW
                    },
                    attrs: {
                      radius: "",
                      color: "primary",
                      icon: "checklist",
                      "data-cy": "toggle-send-files-to-flow-selection",
                      disabled: !_vm.canEdit
                    },
                    on: { click: _vm.toggleSendFilesToFlowSelection }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.navigationElementsSelectionEnabled
                            ? _vm.selectedNavigationElements.length +
                                "/" +
                                _vm.maxSendFilesToFlowSelection
                            : ""
                        ) +
                        " "
                    )
                  ]
                ),
                _vm.navigationElementsSelectionEnabled
                  ? _c("vs-button", {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED082",
                          expression: "'ED082'"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Aceptar selección",
                          expression: "'Aceptar selección'"
                        }
                      ],
                      staticClass: "ml-2",
                      attrs: {
                        radius: "",
                        color: "success",
                        icon: "check",
                        "data-cy": "accept-selection"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleAcceptSelection()
                        }
                      }
                    })
                  : _vm._e(),
                _vm.navigationElementsSelectionEnabled
                  ? _c("vs-button", {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED082",
                          expression: "'ED082'"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Cancelar selección",
                          expression: "'Cancelar selección'"
                        }
                      ],
                      staticClass: "ml-2",
                      attrs: {
                        radius: "",
                        color: "danger",
                        icon: "close",
                        "data-cy": "cancel-selection"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleCancelSelection()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED094",
                  expression: "'ED094'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement &&
                    _vm.activeElement.type === "file" &&
                    _vm.canWrite,
                  expression:
                    "activeElement && activeElement.type === 'file' && canWrite"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Editar datos del documento",
                  expression: "'Editar datos del documento'"
                }
              ],
              staticClass: "action mr-2",
              class: { "cursor-not-allowed": _vm.isReadOnly },
              attrs: {
                radius: "",
                color: "primary",
                icon: "edit",
                "data-cy": "edit-file",
                disabled: _vm.isReadOnly
              },
              on: { click: _vm.editDataFile }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED241",
                  expression: "'ED241'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement &&
                    _vm.activeElement.type === "file" &&
                    _vm.canWrite &&
                    _vm.isDocx,
                  expression:
                    "activeElement && activeElement.type === 'file' && canWrite && isDocx"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Editar el documento",
                  expression: "'Editar el documento'"
                }
              ],
              staticClass: "action mr-2",
              class: { "cursor-not-allowed": _vm.isReadOnly || !_vm.canEdit },
              attrs: {
                radius: "",
                color: "primary",
                icon: "edit_off",
                "data-cy": "edit-document",
                disabled: _vm.isReadOnly || !_vm.canEdit
              },
              on: { click: _vm.openEdictDocument }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeElement && _vm.activeElement.type === "file",
                  expression: "activeElement && activeElement.type === 'file'"
                },
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED085",
                  expression: "'ED085'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Kanban de archivo",
                  expression: "'Kanban de archivo'"
                }
              ],
              staticClass: "action mr-2",
              class: { "cursor-not-allowed": _vm.noHavPermissions },
              attrs: {
                radius: "",
                color: "primary",
                icon: "dashboard",
                "data-cy": "file-kanban",
                disabled: _vm.noHavPermissions
              },
              on: { click: _vm.goToKanban }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED095",
                  expression: "'ED095'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeElement && _vm.activeElement.type === "file",
                  expression: "activeElement && activeElement.type === 'file'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Eliminar documento",
                  expression: "'Eliminar documento'"
                }
              ],
              staticClass: "action mr-2",
              class: { "cursor-not-allowed": _vm.userPermissions.write === 0 },
              attrs: {
                radius: "",
                color: "primary",
                icon: "delete",
                "data-cy": "delete-file",
                disabled: _vm.userPermissions.write === 0
              },
              on: { click: _vm.deleteFile }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "RPS99",
                  expression: "'RPS99'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement &&
                    _vm.activeElement.type === "file" &&
                    _vm.activeElement.codeType === "CPSH",
                  expression:
                    "activeElement && activeElement.type === 'file'\n          && activeElement.codeType === 'CPSH'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Editar información del convenio",
                  expression: "'Editar información del convenio'"
                }
              ],
              staticClass: "action mr-2",
              attrs: {
                radius: "",
                color: "primary",
                icon: "supervisor_account",
                "data-cy": "edit-cpsh-info"
              },
              on: { click: _vm.editCpshInfo }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED240",
                  expression: "'ED240'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement && _vm.activeElement.type === "folder",
                  expression: "activeElement && activeElement.type === 'folder'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Reglas de la carpeta",
                  expression: "'Reglas de la carpeta'"
                }
              ],
              staticClass: "action mr-2",
              class: {
                "cursor-not-allowed":
                  !_vm.isSuperAdmin &&
                  _vm.userPermissions.read === 0 &&
                    _vm.userPermissions.write === 0 &&
                    _vm.userPermissions.totalControl === 0
              },
              attrs: {
                radius: "",
                color: "primary",
                icon: "settings",
                "data-cy": "configure-rule",
                disabled:
                  !_vm.isSuperAdmin &&
                  _vm.userPermissions.read === 0 &&
                    _vm.userPermissions.write === 0 &&
                    _vm.userPermissions.totalControl === 0
              },
              on: { click: _vm.configureRules }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "RPS82",
                  expression: "'RPS82'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement && _vm.activeElement.type === "folder",
                  expression: "activeElement && activeElement.type === 'folder'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Bloquear edición en linea",
                  expression: "'Bloquear edición en linea'"
                }
              ],
              staticClass: "action mr-2",
              class: {
                "cursor-not-allowed":
                  !_vm.isSuperAdmin &&
                  _vm.userPermissions.read === 0 &&
                    _vm.userPermissions.write === 0 &&
                    _vm.userPermissions.totalControl === 0
              },
              attrs: {
                radius: "",
                color: "primary",
                icon: "lock",
                "data-cy": "configure-block-editing",
                disabled:
                  !_vm.isSuperAdmin &&
                  _vm.userPermissions.read === 0 &&
                    _vm.userPermissions.write === 0 &&
                    _vm.userPermissions.totalControl === 0
              },
              on: { click: _vm.handleConfigureLockEditing }
            }),
            _c("vs-button", {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "RPS83",
                  expression: "'RPS83'"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeElement && _vm.activeElement.type === "folder",
                  expression: "activeElement && activeElement.type === 'folder'"
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Marcar como contenedora de templates",
                  expression: "'Marcar como contenedora de templates'"
                }
              ],
              staticClass: "action mr-2",
              class: {
                "cursor-not-allowed":
                  !_vm.isSuperAdmin &&
                  _vm.userPermissions.read === 0 &&
                    _vm.userPermissions.write === 0 &&
                    _vm.userPermissions.totalControl === 0
              },
              attrs: {
                radius: "",
                color: "primary",
                "icon-pack": "feather",
                icon: "icon-package",
                "data-cy": "configure-template-editing",
                disabled:
                  !_vm.isSuperAdmin &&
                  _vm.userPermissions.read === 0 &&
                    _vm.userPermissions.write === 0 &&
                    _vm.userPermissions.totalControl === 0
              },
              on: { click: _vm.handleConfigureTemplate }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "col-md-12",
          on: {
            dragover: _vm.dragover,
            dragleave: _vm.dragleave,
            drop: _vm.drop
          }
        },
        [
          _vm.showDrangAndDropUploader
            ? _c(
                "div",
                {
                  staticClass:
                    "mt-4 wrap-table shadow bg-white rounded overflow-y-scroll view-table drag"
                },
                [
                  _c("input", {
                    ref: "file",
                    staticClass: "hidden",
                    attrs: {
                      type: "file",
                      multiple: "",
                      name: "fields[assetsFieldHandle][]",
                      id: "assetsFieldHandle"
                    },
                    on: { change: _vm.onChange }
                  }),
                  _c("div", { staticClass: "help" }, [
                    _vm._v(
                      " Suelta aquí los archivos que quieres subir a la carpeta "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.elementName))]),
                    _c("br"),
                    _vm._v(" Se subirán automáticamente en cuanto los sueltes ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "drop-icon-holder" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "drop-icon",
                        attrs: { icon: ["fa", "arrow-alt-circle-down"] }
                      })
                    ],
                    1
                  ),
                  _vm.filesToUpload.length > 0
                    ? _c("div", { staticClass: "uploading-progress" }, [
                        _c("div", { staticClass: "progress-wrapper" }, [
                          _c("div", {
                            staticClass:
                              "h-5 animate-pulse bg-grey-light rounded-pill w-5 mr-2 progress-content"
                          }),
                          _c("div", { staticClass: "progress-content" }, [
                            _vm._v(" Subiendo "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.filesToUpload.length))
                            ]),
                            _vm._v(
                              " archivos (" + _vm._s(_vm.progress) + " %) "
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          !_vm.dragging
            ? _c(
                "div",
                {
                  staticClass:
                    "mt-4 wrap-table shadow bg-white rounded overflow-y-scroll view-table"
                },
                [
                  _c("table", { staticClass: "w-100 rounded" }, [
                    _c(
                      "thead",
                      {
                        staticClass: "fb-bg-primary",
                        staticStyle: { color: "white" }
                      },
                      [
                        _c("tr", [
                          _vm.navigationElementsSelectionEnabled
                            ? _c("th", [_vm._v(" Selección ")])
                            : _vm._e(),
                          _c("th", [_vm._v(" Estado ")]),
                          _c("th", [_vm._v(" Nombre ")]),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(" Tamaño ")
                          ]),
                          _c("th", [_vm._v(" Fecha Creación ")]),
                          _c("th", [_vm._v(" Propietario ")]),
                          _c("th", [_vm._v(" Versiones anteriores ")])
                        ])
                      ]
                    ),
                    _c(
                      "tbody",
                      { attrs: { id: "folder-elements" } },
                      [
                        _vm._l(_vm.folderElements, function(element) {
                          return _c("NavigationElement", {
                            key: element.id,
                            attrs: { element: element, "data-cy": "folder" }
                          })
                        }),
                        _vm._l(_vm.fileElements, function(element) {
                          return _c("NavigationElement", {
                            key: element.id,
                            attrs: {
                              element: element,
                              "data-cy": "file",
                              "selection-enabled":
                                _vm.navigationElementsSelectionEnabled,
                              "is-selectable": _vm.isSelectableNavigationElement(
                                element
                              )
                            },
                            on: {
                              "select-navigation-element":
                                _vm.handleSelectNavigationElement
                            }
                          })
                        }),
                        _vm.isEmptyFolder
                          ? _c("tr", [
                              _c("td", { attrs: { colspan: "5" } }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex justify-center m-5" },
                                  [
                                    _c("span", [
                                      _vm._v("Ups! esta carpeta esta vacía.")
                                    ])
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loadingElements,
                            expression: "loadingElements"
                          }
                        ]
                      },
                      [
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-50",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loadingElements,
                            expression: "loadingElements"
                          }
                        ]
                      },
                      [
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-50",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "pl-5 pt-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm.modalName
        ? _c("FileFormView", { attrs: { isEdit: _vm.isEdit } })
        : _vm._e(),
      _vm.modalName
        ? _c("FolderFormView", { attrs: { isEdit: _vm.isEdit } })
        : _vm._e(),
      _vm.modalName ? _c("NewCustomDocument") : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            id: "editCpshModal",
            title: _vm.cpshModalTitle,
            "no-close-on-backdrop": "",
            "hide-footer": "",
            centered: "",
            size: "lg",
            "data-cy": "edit-cpsh-modal"
          },
          model: {
            value: _vm.showEditCpshModal,
            callback: function($$v) {
              _vm.showEditCpshModal = $$v
            },
            expression: "showEditCpshModal"
          }
        },
        [
          _c("b-overlay", { attrs: { show: _vm.loadingCpshData } }, [
            _vm.cpshData
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.editableFields, function(field) {
                      return _c(
                        "div",
                        { key: field.id, staticClass: "mb-3" },
                        [
                          _c("label", [
                            _c("strong", [_vm._v(_vm._s(field.title))]),
                            !field.opcional
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              : _vm._e()
                          ]),
                          field.type === "usuarios"
                            ? _c("list-user", {
                                staticClass: "mb-1",
                                attrs: {
                                  autocomplete: "",
                                  label: "",
                                  name: "cpshField-" + field.id,
                                  "data-cy": "cpsh-field-" + field.id,
                                  "data-vv-as": field.title
                                },
                                on: {
                                  "full-user": function($event) {
                                    _vm.cpshEditForm[
                                      field.id + "Complete"
                                    ] = $event
                                  }
                                },
                                model: {
                                  value: _vm.cpshEditForm[field.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.cpshEditForm, field.id, $$v)
                                  },
                                  expression: "cpshEditForm[field.id]"
                                }
                              })
                            : field.type === "grupos"
                            ? _c("v-select", {
                                attrs: {
                                  name: "cpshField-" + field.id,
                                  "data-cy": "cpsh-field-" + field.id,
                                  placeholder: "Seleccione " + field.title,
                                  options: _vm.cpshCompanyGroups,
                                  loading: _vm.loadingCpshGroups,
                                  label: "nombre"
                                },
                                model: {
                                  value: _vm.cpshEditForm[field.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.cpshEditForm, field.id, $$v)
                                  },
                                  expression: "cpshEditForm[field.id]"
                                }
                              })
                            : field.type === "texto"
                            ? _c("b-form-input", {
                                attrs: {
                                  "data-cy": "cpsh-field-" + field.id,
                                  placeholder: field.placeholder || field.title
                                },
                                model: {
                                  value: _vm.cpshEditForm[field.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.cpshEditForm, field.id, $$v)
                                  },
                                  expression: "cpshEditForm[field.id]"
                                }
                              })
                            : field.type === "textolargo" ||
                              field.type === "textomail"
                            ? _c("b-form-textarea", {
                                attrs: {
                                  "data-cy": "cpsh-field-" + field.id,
                                  placeholder: field.placeholder || field.title,
                                  rows: "3"
                                },
                                model: {
                                  value: _vm.cpshEditForm[field.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.cpshEditForm, field.id, $$v)
                                  },
                                  expression: "cpshEditForm[field.id]"
                                }
                              })
                            : field.type === "correomultiple"
                            ? _c("b-form-input", {
                                attrs: {
                                  "data-cy": "cpsh-field-" + field.id,
                                  placeholder:
                                    "correo1@ejemplo.com, correo2@ejemplo.com"
                                },
                                model: {
                                  value: _vm.cpshEditForm[field.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.cpshEditForm, field.id, $$v)
                                  },
                                  expression: "cpshEditForm[field.id]"
                                }
                              })
                            : field.type === "sino"
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "btn-block",
                                  attrs: {
                                    variant: "primary",
                                    "data-cy": "cpsh-field-" + field.id
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.cpshEditForm[field.id] =
                                        _vm.cpshEditForm[field.id] === "si"
                                          ? "no"
                                          : "si"
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.cpshEditForm[field.id] === "si"
                                          ? "Sí"
                                          : "No"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : field.type === "opciones"
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.cpshEditForm[field.id],
                                      expression: "cpshEditForm[field.id]"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    "data-cy": "cpsh-field-" + field.id
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.cpshEditForm,
                                        field.id,
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(field.opciones || [], function(option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option.valor,
                                      domProps: { value: option.valor }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(option.descripcion) + " "
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : field.type === "info"
                            ? _c(
                                "p",
                                {
                                  staticClass: "text-muted small mb-0",
                                  attrs: { "data-cy": "cpsh-field-" + field.id }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(field.default || "") + " "
                                  )
                                ]
                              )
                            : _c(
                                "b-alert",
                                {
                                  staticClass: "py-1 mb-0",
                                  attrs: { show: "", variant: "warning" }
                                },
                                [
                                  _vm._v(
                                    " Tipo de campo no soportado: " +
                                      _vm._s(field.type) +
                                      " "
                                  )
                                ]
                              ),
                          _vm.cpshFieldErrors[field.id]
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "text-danger text-sm form-error-message"
                                },
                                [
                                  _vm._v(
                                    " El campo " +
                                      _vm._s(field.title) +
                                      " es obligatorio "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    _c(
                      "div",
                      { staticClass: "text-right mt-3" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mr-2",
                            attrs: {
                              variant: "outline-secondary",
                              "data-cy": "cpsh-cancel"
                            },
                            on: {
                              click: function($event) {
                                _vm.showEditCpshModal = false
                              }
                            }
                          },
                          [_vm._v(" Cancelar ")]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              disabled: _vm.savingCpsh,
                              "data-cy": "cpsh-save"
                            },
                            on: { click: _vm.saveCpshInfo }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.savingCpsh
                                    ? "Guardando..."
                                    : "Guardar cambios"
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              : !_vm.loadingCpshData
              ? _c("div", { staticClass: "text-center py-4" }, [
                  _c("p", { staticClass: "text-danger" }, [
                    _vm._v("No se pudo cargar la información del convenio.")
                  ])
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "fillInfoFile",
          attrs: {
            "no-close-on-backdrop": "",
            title: "Información para el Expediente",
            id: "fillInfoFile",
            "hide-footer": "",
            centered: ""
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("list-user-groups", {
                  ref: "groupUserFile",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    "data-cy": "select-grupo",
                    "only-groups": "",
                    label: "Grupo al que irá asociado el expediente (*)",
                    name: "groupUserFile"
                  },
                  model: {
                    value: _vm.groupUserFile,
                    callback: function($$v) {
                      _vm.groupUserFile = $$v
                    },
                    expression: "groupUserFile"
                  }
                }),
                _vm.errorGroup && !_vm.groupUserFile
                  ? _c("div", [
                      _c("h4", { staticClass: "text-danger" }, [
                        _vm._v(
                          " Por favor selecciona un grupo para asociarlo al expediente "
                        )
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          disabled: _vm.loadingFile,
                          variant: "primary",
                          "data-cy": "boton-vale"
                        },
                        on: { click: _vm.sendToFlowGore }
                      },
                      [_vm._v(" Vale ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "lockEditingModal",
            title: "Configurar bloqueo de edición en línea",
            "hide-footer": "",
            centered: "",
            "data-cy": "modal-lock-editing"
          },
          model: {
            value: _vm.showLockEditingModal,
            callback: function($$v) {
              _vm.showLockEditingModal = $$v
            },
            expression: "showLockEditingModal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "mb-3",
              attrs: { "data-cy": "modal-lock-editing-info" }
            },
            [
              _vm._v(
                " ¿Desea bloquear la edición en línea de archivos para la carpeta "
              ),
              _c("b", [
                _vm._v(_vm._s(_vm.activeElement && _vm.activeElement.name))
              ]),
              _vm._v(" ? ")
            ]
          ),
          _c(
            "div",
            { staticClass: "d-flex align-items-center mb-3" },
            [
              _c(
                "label",
                {
                  staticClass: "mr-2",
                  attrs: {
                    for: "switch-lock-editing",
                    "data-cy": "label-switch-lock-editing"
                  }
                },
                [_vm._v(" Bloquear edición en línea ")]
              ),
              _c("b-form-checkbox", {
                attrs: {
                  id: "switch-lock-editing",
                  switch: "",
                  "data-cy": "switch-lock-editing"
                },
                model: {
                  value: _vm.lockEditingSwitch,
                  callback: function($$v) {
                    _vm.lockEditingSwitch = $$v
                  },
                  expression: "lockEditingSwitch"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end" },
            [
              !_vm.loadingLockEditing
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        variant: "primary",
                        "data-cy": "btn-confirm-lock-editing",
                        disabled: _vm.loadingLockEditing
                      },
                      on: { click: _vm.confirmLockEditing }
                    },
                    [_vm._v(" Confirmar ")]
                  )
                : _vm._e(),
              _vm.loadingLockEditing
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "primary", disabled: "" }
                    },
                    [
                      _c("b-spinner", {
                        staticClass: "mr-2",
                        attrs: { small: "", type: "grow" }
                      }),
                      _vm._v(" Procesando... ")
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "secondary",
                    "data-cy": "btn-cancel-lock-editing",
                    disabled: _vm.loadingLockEditing
                  },
                  on: {
                    click: function($event) {
                      _vm.showLockEditingModal = false
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              )
            ],
            1
          ),
          _vm.lockEditingFeedback
            ? _c(
                "b-alert",
                {
                  staticClass: "mt-3",
                  attrs: {
                    variant: "success",
                    show: "",
                    "data-cy": "feedback-lock-editing"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.lockEditingFeedback) + " ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "templateModal",
            title: "Configurar como plantilla",
            "hide-footer": "",
            centered: "",
            "data-cy": "modal-template-editing"
          },
          model: {
            value: _vm.showTemplateModal,
            callback: function($$v) {
              _vm.showTemplateModal = $$v
            },
            expression: "showTemplateModal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "mb-3",
              attrs: { "data-cy": "modal-template-editing-info" }
            },
            [
              _vm._v(" ¿Desea marcar la carpeta "),
              _c("b", [
                _vm._v(_vm._s(_vm.activeElement && _vm.activeElement.name))
              ]),
              _vm._v(" como plantilla? ")
            ]
          ),
          _c(
            "div",
            { staticClass: "d-flex align-items-center mb-3" },
            [
              _c(
                "label",
                {
                  staticClass: "mr-2",
                  attrs: {
                    for: "switch-template-editing",
                    "data-cy": "label-switch-template-editing"
                  }
                },
                [_vm._v(" Marcar como plantilla ")]
              ),
              _c("b-form-checkbox", {
                attrs: {
                  id: "switch-template-editing",
                  switch: "",
                  "data-cy": "switch-template-editing"
                },
                model: {
                  value: _vm.templateSwitch,
                  callback: function($$v) {
                    _vm.templateSwitch = $$v
                  },
                  expression: "templateSwitch"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end" },
            [
              !_vm.loadingTemplate
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        variant: "primary",
                        "data-cy": "btn-confirm-template-editing",
                        disabled: _vm.loadingTemplate
                      },
                      on: { click: _vm.confirmTemplate }
                    },
                    [_vm._v(" Confirmar ")]
                  )
                : _vm._e(),
              _vm.loadingTemplate
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "primary", disabled: "" }
                    },
                    [
                      _c("b-spinner", {
                        staticClass: "mr-2",
                        attrs: { small: "", type: "grow" }
                      }),
                      _vm._v(" Procesando... ")
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "secondary",
                    "data-cy": "btn-cancel-template-editing",
                    disabled: _vm.loadingTemplate
                  },
                  on: {
                    click: function($event) {
                      _vm.showTemplateModal = false
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              )
            ],
            1
          ),
          _vm.templateFeedback
            ? _c(
                "b-alert",
                {
                  staticClass: "mt-3",
                  attrs: {
                    variant: "success",
                    show: "",
                    "data-cy": "feedback-template-editing"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.templateFeedback) + " ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "newTemplateDocumentModal",
            title: "Crear documento desde template",
            "hide-footer": "",
            centered: "",
            "data-cy": "modal-new-document-template",
            "no-close-on-backdrop": ""
          },
          model: {
            value: _vm.showNewTemplateDocumentModal,
            callback: function($$v) {
              _vm.showNewTemplateDocumentModal = $$v
            },
            expression: "showNewTemplateDocumentModal"
          }
        },
        [
          _c("div", { staticClass: "mb-3" }, [
            _vm.loadingTemplates
              ? _c(
                  "div",
                  [
                    _c("b-spinner", {
                      staticClass: "mr-2",
                      attrs: { small: "", type: "grow" }
                    }),
                    _vm._v(" Cargando templates... ")
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _vm.wizardStep === 1
                      ? [
                          _c("div", { staticClass: "mb-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.templateSearch,
                                  expression: "templateSearch"
                                }
                              ],
                              staticClass: "form-control",
                              staticStyle: { "max-width": "400px" },
                              attrs: {
                                type: "text",
                                placeholder: "Buscar por nombre..."
                              },
                              domProps: { value: _vm.templateSearch },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.templateSearch = $event.target.value
                                }
                              }
                            })
                          ]),
                          _c("table", { staticClass: "template-table" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [_vm._v("Nombre")]),
                                _c("th", [_vm._v("Fecha creación")]),
                                _c("th", [_vm._v("Tamaño")])
                              ])
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.filteredTemplatesFiles, function(
                                file
                              ) {
                                return _c(
                                  "tr",
                                  {
                                    key: file.id,
                                    class: {
                                      "selected-row":
                                        _vm.selectedTemplateFile &&
                                        _vm.selectedTemplateFile.id === file.id
                                    },
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectTemplateFile(file)
                                      }
                                    }
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(file.nombre))]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          file.fechaCreacion
                                            ? new Date(
                                                file.fechaCreacion
                                              ).toLocaleDateString()
                                            : "-"
                                        )
                                      )
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          file.pesoArchivo
                                            ? (file.pesoArchivo / 1024).toFixed(
                                                1
                                              ) + " KB"
                                            : "-"
                                        )
                                      )
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm.filteredTemplatesFiles.length === 0
                            ? _c(
                                "div",
                                { staticClass: "text-center text-muted my-4" },
                                [
                                  _vm._v(
                                    " No se encontraron documentos de template. "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.templatesPagination.totalPaginas > 1
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-between items-center mt-4"
                                },
                                [
                                  _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.templatesPagination
                                            .paginaActual === 1
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.fetchTemplatesFiles(
                                            _vm.templatesPagination
                                              .paginaActual - 1
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Anterior ")]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      "Página " +
                                        _vm._s(
                                          _vm.templatesPagination.paginaActual
                                        ) +
                                        " de " +
                                        _vm._s(
                                          _vm.templatesPagination.totalPaginas
                                        )
                                    )
                                  ]),
                                  _c(
                                    "vs-button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.templatesPagination
                                            .paginaActual ===
                                          _vm.templatesPagination.totalPaginas
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.fetchTemplatesFiles(
                                            _vm.templatesPagination
                                              .paginaActual + 1
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Siguiente ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "mt-4 text-right" },
                            [
                              _c(
                                "vs-button",
                                {
                                  attrs: { color: "danger" },
                                  on: {
                                    click: function($event) {
                                      _vm.showNewTemplateDocumentModal = false
                                    }
                                  }
                                },
                                [_vm._v(" Cancelar ")]
                              )
                            ],
                            1
                          )
                        ]
                      : _vm.wizardStep === 2
                      ? [
                          _c("div", { staticClass: "wizard-step-2" }, [
                            _c("div", { staticClass: "mb-3" }, [
                              _c(
                                "label",
                                { attrs: { for: "templateNameInput" } },
                                [_c("b", [_vm._v("Nombre del documento:")])]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editableTemplateName,
                                    expression: "editableTemplateName"
                                  }
                                ],
                                staticClass: "form-control",
                                staticStyle: {
                                  width: "100%",
                                  "max-width": "400px",
                                  display: "block"
                                },
                                attrs: { id: "templateNameInput" },
                                domProps: { value: _vm.editableTemplateName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.editableTemplateName =
                                      $event.target.value
                                  }
                                }
                              })
                            ]),
                            _c(
                              "div",
                              { staticClass: "mt-4 text-right" },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "primary" },
                                    on: { click: _vm.backToTemplateList }
                                  },
                                  [_vm._v("Volver")]
                                ),
                                _c(
                                  "vs-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.editableTemplateName,
                                      color: "success"
                                    },
                                    on: { click: _vm.confirmTemplateSelection }
                                  },
                                  [_vm._v("Crear documento ")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
          ])
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "loadingCopyTemplateDocumentModal",
            title: "Creando documento desde template",
            "hide-footer": "",
            centered: "",
            "data-cy": "modal-loading-copy-template-document"
          },
          model: {
            value: _vm.loadingCopyTemplateDocument,
            callback: function($$v) {
              _vm.loadingCopyTemplateDocument = $$v
            },
            expression: "loadingCopyTemplateDocument"
          }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center" },
            [
              _c("b-spinner", { attrs: { label: "Cargando..." } }),
              _c("span", { staticClass: "mt-2" }, [
                _vm._v(" Creando documento, por favor espera... ")
              ])
            ],
            1
          )
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "openAfterCopyModal",
            title: "Documento creado correctamente",
            "hide-footer": "",
            centered: "",
            "data-cy": "modal-open-after-copy"
          },
          model: {
            value: _vm.showOpenAfterCopyModal,
            callback: function($$v) {
              _vm.showOpenAfterCopyModal = $$v
            },
            expression: "showOpenAfterCopyModal"
          }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column justify-content-between" },
            [
              _c("span", { staticClass: "mb-3" }, [
                _vm._v("El documento se guardó con éxito.")
              ]),
              _c(
                "div",
                { staticClass: "d-flex  justify-content-around" },
                [
                  _c(
                    "vs-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.handleOpenAfterCopy(false)
                        }
                      }
                    },
                    [_vm._v(" Cerrar ")]
                  ),
                  _c(
                    "vs-button",
                    {
                      staticClass: "mr-2",
                      attrs: { color: "success" },
                      on: {
                        click: function($event) {
                          return _vm.handleOpenAfterCopy(true)
                        }
                      }
                    },
                    [_vm._v(" Abrir documento ")]
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }